import styled from 'styled-components';

export const ConsentBody = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
`;

export const ConsentFormLineContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

export const ConsentFormLineText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 30px;
  flex: 1;
`;

export const ConsentFormLineViewOption = styled.a`
  margin-right: 30px;
`;

export const ConsentFormLineDeleteOption = styled.p`
  color: red;
  cursor: pointer;
`;
